// @ts-strict-ignore
import { Box, Flex, OldText, breakpoints } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

const Icon = styled.div`
  color: ${(p) => p.theme.colors.tabaccoBrown};
  display: grid;
  grid-template-columns: 2rem 1fr;
  text-align: left;
  flex-direction: row;
  align-items: center;
  column-gap: 1.25rem;

  img {
    width: 2rem;
    height: auto;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    grid-template-columns: 2.5rem 1fr;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    margin-bottom: 0;
    column-gap: 1.25rem;

    img {
      width: 2.5rem;
    }
  }
`

const iconKeys = ['delivery', 'lock', 'free-returns', 'always-insured']

const icons = {
  delivery: ['/images/delivery-time_mobile.svg', '/images/delivery-time_desktop.svg'],
  lock: ['/images/lock_mobile.svg', '/images/lock_desktop.svg'],
  'free-returns': ['/images/free_returns_mobile.svg', '/images/free_returns_desktop.svg'],
  'always-insured': ['/images/always_insured_mobile.svg', '/images/always_insured_desktop.svg'],
}

const USPs: FC = () => {
  const { t } = useTranslation('global')
  return (
    <>
      <Flex
        flexDirection="column"
        alignItems={'flex-start'}
        my={{ _: '2rem' }}
        ml={{ _: 0, large: '-0.25rem' }}
      >
        {iconKeys.map((icon, index) => (
          <Icon key={index}>
            <Box display={['block', 'none']}>
              <img src={icons[icon][0]} alt={icon} />
            </Box>
            <Box display={['none', 'block']}>
              <img src={icons[icon][1]} alt={icon} />
            </Box>
            <OldText
              variant="small"
              color="tabaccoBrown"
              mb="0"
              dangerouslySetInnerHTML={{
                __html: t(`${icon}`),
              }}
            ></OldText>
          </Icon>
        ))}
      </Flex>
    </>
  )
}

export default USPs
